import {Outlet} from 'react-router-dom';

import NewPriceContainer from './AddNewPrice';
import FrontdeskButton from '~/components/FrontdeskButton';
import FrontdeskSearchbox from '~/components/FrontdeskSearchBox';
import TabsWithRouting from '~/components/TabsWithRouting';

import {PRICING_LIST_EXACT_ROUTE, tabItems} from './constants';

import {
  ArrowLeftIcon,
  NewPriceBarChartSquareIcon,
  SearchRefractionIcon,
} from '~/assets/svgs';

interface IPricingListComponentProps {
  handleBackClick: () => void;
  handleNewPriceClick: () => void;
  isModalOpen: boolean;
  handleCloseClick: () => void;
  searchText: string;
  debouncedSearchTerm: string;
  setSearchText: (value: string) => void;
}

const PricingListComponent = ({
  handleBackClick,
  handleNewPriceClick,
  isModalOpen,
  handleCloseClick,
  searchText,
  debouncedSearchTerm,
  setSearchText,
}: IPricingListComponentProps) => {
  return (
    <div className="flex flex-col flex-1 font-primary bg-primary overflow-auto">
      <header className="flex items-center justify-start mx-10 border-b-header">
        <FrontdeskButton
          title="Back"
          startIcon={<ArrowLeftIcon />}
          className="!pt-6 !pb-6 !normal-case !font-normal !text-base !leading-6 !tracking-tight text-primary-dark hover:!bg-transparent"
          onClick={handleBackClick}
          variant="outlined"
        />
      </header>
      <main className="flex flex-col justify-start flex-1 mt-4 ml-10 mr-10 mb-6 overflow-x-hidden overflow-y-auto">
        <div className="flex items-center mx-2 my-4">
          <h1 className="flex1 font-semibold text-2xl leading-7 tracking-tight text-primary-dark">
            Pricing List
          </h1>
          <FrontdeskButton
            title="New Price"
            onClick={handleNewPriceClick}
            startIcon={<NewPriceBarChartSquareIcon />}
            className="ms-auto me-4"
          />
          <FrontdeskSearchbox
            value={searchText}
            placeholder="Search"
            startIcon={<SearchRefractionIcon />}
            onChange={setSearchText}
          />
        </div>
        <TabsWithRouting tabs={tabItems} basePath={PRICING_LIST_EXACT_ROUTE} />
        <div className="flex flex-col mt-4 overflow-auto">
          {/* this will render <PricingTable /> as a children routes*/}
          <Outlet context={{debouncedSearchTerm}} />

          {isModalOpen ? (
            <NewPriceContainer
              isModalOpen={isModalOpen}
              handleCloseClick={handleCloseClick}
            />
          ) : null}
        </div>
      </main>
    </div>
  );
};

export default PricingListComponent;
